import { useEffect, useState } from 'react'
import { authHeaders } from '../utils/authFetch'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080'

export default function useProfilingHistory() {
  const [history, setHistory] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchHistory = async () => {
    setLoading(true)
    try {
      const res = await fetch(`${BASE_URL}/api/customer-profiling-history`, { headers: authHeaders() })
      if (res.ok) setHistory(await res.json())
    } catch (err) {
      console.error('fetchHistory error:', err)
    }
    setLoading(false)
  }

  const saveProfilingRun = async (profiles) => {
    try {
      const res = await fetch(`${BASE_URL}/api/customer-profiling-history`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({ profiles }),
      })
      if (!res.ok) return { data: null, error: 'Failed to save profiling run' }
      const data = await res.json()
      setHistory(prev => [data, ...prev])
      return { data, error: null }
    } catch (err) {
      console.error('saveProfilingRun error:', err)
      return { data: null, error: err.message }
    }
  }

  const deleteProfilingRun = async (id) => {
    try {
      const res = await fetch(`${BASE_URL}/api/customer-profiling-history/${id}`, { method: 'DELETE', headers: authHeaders() })
      if (!res.ok) return { error: 'Failed to delete profiling run' }
      setHistory(prev => prev.filter(h => h.id !== id))
      return { error: null }
    } catch (err) {
      console.error('deleteProfilingRun error:', err)
      return { error: err.message }
    }
  }

  useEffect(() => {
    fetchHistory()
  }, [])

  return { history, loading, saveProfilingRun, deleteProfilingRun, fetchHistory }
}